<div #myDropdown="bs-dropdown" dropdown class="dropdown" style="float: right;"
     [autoClose]="includeManual ? false : true"
     [insideClick]="false"
     (onShown)="onShown()"
     >
    <button dropdownToggle class="btn btn-dropdown dropdown-link">
        {{selected.display}}
        <span class="caret" style="margin-left: 8px"></span>
    </button>

    <ul *dropdownMenu [ngClass]="{ 'select-dropdown': true, 'dropdown-menu' : true, 'dropdown-menu-right': useDropdownMenuRight }" role="menu">
        <li role="menuitem" (click)="selectThis(preset)" *ngFor="let preset of presetDateRanges">
            <div class="dropdown-item">
                {{preset.display}}
            </div>
        </li>
        <li role="menuitem" style="min-width: 380px" *ngIf="includeManual">
            <div (click)='cancelAutoClose($event)'>
                <my-date-range-selector [category]="category"></my-date-range-selector>
            </div>
            <button class="btn btn-primary" style="min-width: 1px"
                    (click)="selectManualRange()">Go</button>
        </li>
    </ul>
</div>
